import createClient from "openapi-fetch";
import type { components, paths } from "./api.types";

export const TOKEN_STORAGE_KEY = "snippland-token";

/**
 * Typed API client backed by the generated OpenAPI types. The backend serves
 * everything under /api on the same origin, so a relative baseUrl is enough.
 */
export const api = createClient<paths>({ baseUrl: "/api" });

// Inject the JWT (when present) into every request. Read from localStorage at
// request time so it stays in sync with sign-in / sign-out without imports.
api.use({
  onRequest({ request }) {
    try {
      const token = localStorage.getItem(TOKEN_STORAGE_KEY);
      if (token) request.headers.set("Authorization", `Bearer ${token}`);
    } catch {
      /* localStorage unavailable: send the request anonymously */
    }
    return request;
  },
});

// Convenience aliases for the generated component schemas.
export type Snip = components["schemas"]["server.SnipDTO"];
export type SnipFile = components["schemas"]["server.SnipFileDTO"];
export type User = components["schemas"]["server.UserDTO"];
export type SnipInput = components["schemas"]["server.SnipInput"];
export type UserProfile = components["schemas"]["server.userProfileResponse"];

/** Fetch raw markdown content for a blob id from the CDN-like blob endpoint. */
export async function fetchBlob(blobId: string): Promise<string> {
  const res = await fetch(`/api/blobs/${blobId}`);
  if (!res.ok) throw new Error(`blob ${blobId} failed: ${res.status}`);
  return res.text();
}
